import { render, staticRenderFns } from "./AtualizarTag.vue?vue&type=template&id=12eeabb2&"
import script from "./AtualizarTag.vue?vue&type=script&lang=js&"
export * from "./AtualizarTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports